import { Record } from 'immutable';

export default class WeeklyTimeReportSummary extends Record({
  id: undefined,
  reported: undefined,
  resourceReported: undefined,
  resourceReportedDates: undefined,
  resourceUnreported: undefined,
  subjectForReporting: undefined,
  week: undefined,
  year: undefined,
}) {
}
